module.exports = __webpack_public_path__ + "img/advantage3_1@2x.047cd113.png";